import React, { useEffect, useState } from 'react';
import { PrimaryButton } from '../components/button';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { encryptPayload } from '../utils/encryption';

export default function BusinessAddress() {
    const navigate = useNavigate();
    const [buttonLoading, setButtonLoading] = useState("");
    const [privateAddress, setPrivateAddress] = useState("");
    const [shippingAddress, setShippingAddress] = useState("");
    const [invoiceAddress, setInvoiceAddress] = useState("");
    const [correspondenceAddress, setCorrespondenceAddress] = useState("");
    const [companyAddress, setcompanyAddress] = useState("");
    const [samePrivateAddress, setSamePrivateAddress] = useState("");
    const [sameShippingAddress, setSameShippingAddress] = useState("");
    const [sameInvoicwAddress, setSameInvoicwAddress] = useState("");
    const [sameCorrespondenceAddress, setSameCorrespondenceAddress] = useState("");

    const submitData = async () => {


        let isValid = true;

  if (!samePrivateAddress) {
    toast.error("Please select 'Same as Contact Address' for Private Address");
    isValid = false;
  }

  if (!sameShippingAddress) {
    toast.error("Please select 'Same as Contact Address' for Shipping Address");
    isValid = false;
  }

  if (!sameInvoicwAddress) {
    toast.error("Please select 'Same as Contact Address' for Invoice Address");
    isValid = false;
  }

  if (!sameCorrespondenceAddress) {
    toast.error("Please select 'Same as Company Address' for Correspondence Address");
    isValid = false;
  }


  if (!isValid) return;



        setButtonLoading(true);
        const token = sessionStorage.getItem('registrationToken');
        var deviceId = sessionStorage.getItem('deviceid');
        var userid = sessionStorage.getItem('userid');

        //shipping address
        const encryptedPayload = await encryptPayload({
            "house_no": null,
            "address_info": shippingAddress,
            "city": shippingAddress,
            "postcode": shippingAddress,
            "country_id": "231",
            "shipping_address": true,
            "platform": 'web',
            "extraParamValidation": 'trustedfromweb'
        });
        await axios.post(Constants.BASE_URL + "API-FX-177-BUSINESS-REGISTRATION-COMPANY-ADDRESS", encryptedPayload, {
            headers: {
                fx_key: Constants.SUBSCRIPTION_KEY,
                Authorization: 'Bearer ' + token
            }
        }).then(resp => {
            resp
        }).catch(err => {
            console.log(err.response.data);
            setButtonLoading(false);
            // toast.error('Error',err.response.data.message)
        })

        //invoice address
        const encryptedPayload1 = await encryptPayload({
            "house_no": null,
            "address_info": invoiceAddress,
            "city": invoiceAddress,
            "postcode": invoiceAddress,
            "country_id": "231",
            "invoice_address": true,
            "platform": 'web',
            "extraParamValidation": 'trustedfromweb'
        });
        await axios.post(Constants.BASE_URL + "API-FX-177-BUSINESS-REGISTRATION-COMPANY-ADDRESS", encryptedPayload1, {
            headers: {
                fx_key: Constants.SUBSCRIPTION_KEY,
                Authorization: 'Bearer ' + token
            }
        }).then(resp => {
            resp
        }).catch(err => {
            console.log(err.response.data);
            setButtonLoading(false);
            // toast.error('Error',err.response.data.message)
        })


        //correspondence address
        const encryptedPayload2 = await encryptPayload({
            "house_no": null,
            "address_info": correspondenceAddress,
            "city": correspondenceAddress,
            "postcode": correspondenceAddress,
            "country_id": "231",
            "correspondence_address": true,
            "platform": 'web',
            "extraParamValidation": 'trustedfromweb'
        });
        await axios.post(Constants.BASE_URL + "API-FX-177-BUSINESS-REGISTRATION-COMPANY-ADDRESS", encryptedPayload2, {
            headers: {
                fx_key: Constants.SUBSCRIPTION_KEY,
                Authorization: 'Bearer ' + token
            }
        }).then(resp => {
            resp
        }).catch(err => {
            console.log(err.response.data);
            setButtonLoading(false);
            // toast.error('Error',err.response.data.message)
        })

        //private address
        const encryptedPayload3 = await encryptPayload({
            "house_no": null,
            "address_info": privateAddress,
            "city": privateAddress,
            "postcode": privateAddress,
            "country_id": "231",
            "private_address": true,
            "platform": 'web',
            "extraParamValidation": 'trustedfromweb'
        });
        await axios.post(Constants.BASE_URL + "API-FX-177-BUSINESS-REGISTRATION-COMPANY-ADDRESS", encryptedPayload3, {
            headers: {
                fx_key: Constants.SUBSCRIPTION_KEY,
                Authorization: 'Bearer ' + token
            }
        }).then(resp => {
            resp
        }).catch(err => {
            console.log(err.response.data);
            setButtonLoading(false);
            // toast.error('Error',err.response.data.message)
        })


        const dropPayload = await encryptPayload({
            screen_name: "BUSINESS_ADDRESS_8",
            meta: { privateAddress: privateAddress, correspondenceAddress: correspondenceAddress, invoiceAddress: invoiceAddress, shippingAddress: shippingAddress },
            device_id: deviceId,
            user_id: userid
        });
        await axios.post(Constants.BASE_URL + "API-FX-159-DROPSCREEN", dropPayload, {
            headers: {
                fx_key: Constants.SUBSCRIPTION_KEY
            }
        }).then(dropresponse => {
            dropresponse
            setButtonLoading(false);
            navigate('/SelectOfficer');
        }).catch(dropError => {
            setButtonLoading(false);
            // console.log(dropError);
            toast.error(dropError.response.data.message)
        })

    }
    const loadData = async () => {
        setcompanyAddress(sessionStorage.getItem('selectedcompanyAddress'));
    }
    useEffect(() => {
        loadData()
    })


    return (
        <div className="min-h-screen w-full bg-white flex flex-col">
            <div className="w-full border-b border-[#0B214E33] py-6 px-6">
                <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />
            </div>

            <ToastContainer />

            <div className='flex flex-1 items-center justify-center px-4'>

                <div className="w-full max-w-[720px] mx-auto">


                    <div className="flex items-center mb-4 pt-3 cursor-pointer" onClick={() => navigate("/AboutBusiness")}>
                        <img src="./arrow-left.svg" alt="back" />
                        <span className="text-lg font-bold">Add Address</span>
                    </div>

                    <div className="flex items-center mb-4 bg-custom-gray-light rounded-md w-full">
                        <input
                            type="text"
                            placeholder="Company Address"
                            className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-custom-neutral-900 placeholder:text-sm"
                            value={companyAddress}
                            readOnly
                        />
                    </div>


                    <div className="items-center mb-1 rounded-md w-full">
                        <input
                            type="text"
                            placeholder="Add Private Address"
                            className="w-full p-2 outline-none rounded-md border-2 border-dashed border-black placeholder:text-custom-neutral-900 placeholder:text-sm"
                            value={privateAddress}
                            onChange={(e) => setPrivateAddress(e.target.value)}
                        />
                    </div>
                    <div className='mb-2 mt-5'>
                        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
                            {/* Real checkbox (hidden) */}
                            <input
                                type="checkbox"
                                className="peer sr-only"
                                checked={samePrivateAddress}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setSamePrivateAddress(checked);
                                    setPrivateAddress(checked ? companyAddress : "");
                                }}
                                aria-label="Use same private address as company"
                            />

                            {/* Visual circle */}
                            <span
                                className="
      w-5 h-5 rounded-full grid place-content-center transition-colors
      border border-[#C4C6C1] bg-white
      peer-checked:bg-[#0B214E] peer-checked:border-[#0B214E]
    "
                            >
                                {/* Tick */}
                                <img src="./icons/tick-icon-active.svg" />
                            </span>

                            {/* Optional label text */}
                            <span className="text-sm text-[#0B214E]">Same as contact address</span>
                        </label>

                    </div>

                    <div className="items-center mb-1 rounded-md w-full">
                        <input
                            type="text"
                            placeholder="Add Shipping Address"
                            className="w-full p-2 outline-none rounded-md border-2 border-dashed border-black placeholder:text-custom-neutral-900 placeholder:text-sm"
                            value={shippingAddress}
                            onChange={(e) => setShippingAddress(e.target.value)}
                        />
                    </div>
                    <div className="mb-2 mt-5">
                        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
                            {/* Hidden real checkbox */}
                            <input
                                type="checkbox"
                                className="peer sr-only"
                                checked={sameShippingAddress}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setSameShippingAddress(checked);
                                    setShippingAddress(checked ? companyAddress : "");
                                }}
                                aria-label="Use same contact address as company"
                            />

                            {/* Visual circle */}
                            <span
                                className="
        w-5 h-5 rounded-full grid place-content-center transition-colors
        border border-[#C4C6C1] bg-white
        peer-checked:bg-[#0B214E] peer-checked:border-[#0B214E]
      "
                            >
                                {/* Tick icon (only visible when checked) */}
                              
                                {/* <img
                                    src="./icons/tick-icon-active.svg"
                                    alt=""
                                    className="w-3 h-3 opacity-0 peer-checked:opacity-100 transition-opacity"
                                /> */}
                                 <img
                                    src="./icons/tick-icon-active.svg"
                                />
                            </span>

                            {/* Label text */}
                            <span className="text-sm text-[#0B214E]">Same as contact address</span>
                        </label>
                    </div>


                    <div className="items-center mb-1 rounded-md w-full">
                        <input
                            type="text"
                            placeholder="Add Invoice Address"
                            className="w-full p-2 outline-none rounded-md border-2 border-dashed border-black placeholder:text-custom-neutral-900 placeholder:text-sm"
                            value={invoiceAddress}
                            onChange={(e) => setInvoiceAddress(e.target.value)}
                        />
                    </div>
                    <div className="mt-5 mb-2">
                        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
                            {/* Hidden real checkbox */}
                            <input
                                type="checkbox"
                                className="peer sr-only"
                                checked={sameInvoicwAddress}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setSameInvoicwAddress(checked);
                                    setInvoiceAddress(checked ? companyAddress : "");
                                }}
                                aria-label="Use same contact address as company (invoice)"
                            />

                            {/* Visual circle */}
                            <span
                                className="
        w-5 h-5 rounded-full grid place-content-center transition-colors
        border border-[#C4C6C1] bg-white
        peer-checked:bg-[#0B214E] peer-checked:border-[#0B214E]
      "
                            >
                                {/* Tick icon shows when checked */}
                                {/* <img
                                    src="./icons/tick-icon-active.svg"
                                    alt=""
                                    className="w-3 h-3 opacity-0 peer-checked:opacity-100 transition-opacity"
                                /> */}
                                 <img
                                    src="./icons/tick-icon-active.svg"
                                />
                            </span>

                            {/* Label text */}
                            <span className="text-sm text-[#0B214E]">Same as contact address</span>
                        </label>
                    </div>


                    <div className="items-center mb-1  rounded-md w-full">
                        <input
                            type="text"
                            placeholder="Add Correspondence Address"
                            className="w-full p-2 outline-none rounded-md border-2 border-dashed border-black placeholder:text-custom-neutral-900 placeholder:text-sm"
                            value={correspondenceAddress}
                            onChange={(e) => setCorrespondenceAddress(e.target.value)}
                        />
                    </div>
                    <div className="mt-5 mb-2">
                        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
                            {/* Hidden real checkbox */}
                            <input
                                type="checkbox"
                                className="peer sr-only"
                                checked={sameCorrespondenceAddress}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setSameCorrespondenceAddress(checked);
                                    setCorrespondenceAddress(checked ? companyAddress : "");
                                }}
                                aria-label="Use same contact address as company (correspondence)"
                            />

                            {/* Visual circle */}
                            <span
                                className="
        w-5 h-5 rounded-full grid place-content-center transition-colors
        border border-[#C4C6C1] bg-white
        peer-checked:bg-[#0B214E] peer-checked:border-[#0B214E]
      "
                            >
                                {/* Tick icon shows when checked */}
                                {/* <img
                                    src="./icons/tick-icon-active.svg"
                                    alt=""
                                    className="w-3 h-3 opacity-0 peer-checked:opacity-100 transition-opacity"
                                /> */}
                                <img
                                    src="./icons/tick-icon-active.svg"
                                />
                            </span>

                            {/* Label text */}
                            <span className="text-sm text-[#0B214E]">Same as contact address</span>
                        </label>
                    </div>


                    <PrimaryButton
                        onClick={submitData}
                        label={"Continue"}
                        loading={buttonLoading}
                    />


                </div>
            </div>
        </div>
    );
}